import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useBannerInfoEffect({
    bannerInfo,
    checkProxyActive,
    checkImpersonationActive,
    saveExitBtnClickHandler,
    dispatch,
    setDestructive,
    history,
    getRoutePathWithParams,
    setBannerDetails,
    setConfirmationBanner,
}) {
    useEffectWithErrorLogging(() => {
        if (
            !checkProxyActive() &&
            !checkImpersonationActive() &&
            (bannerInfo || []).filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0
        ) {
            saveExitBtnClickHandler();
            dispatch(setDestructive(true));
            history.push(getRoutePathWithParams('/maintainance'));
            return;
        } else {
            let userInfoMessages = [];
            if (bannerInfo) {
                userInfoMessages = bannerInfo.filter(
                    (item) => item.messageType === 'userInfoMessage'
                );
            }
            dispatch(setBannerDetails(userInfoMessages));
            let confirmationMessages = [];
            if (bannerInfo) {
                confirmationMessages = bannerInfo.filter(
                    (item) => item.messageType === 'userConfirmMessage'
                );
            }
            dispatch(setConfirmationBanner(confirmationMessages));
        }
    }, [bannerInfo]);
}